<template>
  <div class="mt-2 inline w-full shrink-0" v-bind="$attrs">
    <slot />
  </div>
</template>
